import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTracker = ({ currentStep, totalSteps, steps }) => {
  const progressPercentage = ((currentStep) / totalSteps) * 100;

  return (
    <div className="w-full bg-card rounded-xl border border-border shadow-warm p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground font-heading">
            Setup Progress
          </h3>
          <p className="text-sm md:text-base text-muted-foreground font-caption mt-1">
            Step {currentStep} of {totalSteps}
          </p>
        </div>
        <div className="flex items-center gap-2 md:gap-3">
          <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-lg md:text-xl lg:text-2xl font-bold text-primary">
              {Math.round(progressPercentage)}%
            </span>
          </div>
        </div>
      </div>
      <div className="w-full h-2 md:h-3 bg-muted rounded-full overflow-hidden mb-4 md:mb-6">
        <div 
          className="h-full bg-primary transition-all duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isPending = stepNumber > currentStep;

          return (
            <div
              key={step?.id}
              className={`
                flex items-center gap-3 p-3 md:p-4 rounded-lg border transition-all duration-250
                ${isCurrent ? 'bg-primary/10 border-primary' : ''}
                ${isCompleted ? 'bg-success/10 border-success' : ''}
                ${isPending ? 'bg-muted border-border' : ''}
              `}
            >
              <div
                className={`
                  flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center
                  ${isCurrent ? 'bg-primary text-primary-foreground' : ''}
                  ${isCompleted ? 'bg-success text-success-foreground' : ''}
                  ${isPending ? 'bg-muted text-muted-foreground' : ''}
                `}
              >
                {isCompleted ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <span className="text-sm md:text-base font-semibold">{stepNumber}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`
                  text-xs md:text-sm font-medium truncate
                  ${isCurrent ? 'text-primary' : ''}
                  ${isCompleted ? 'text-success' : ''}
                  ${isPending ? 'text-muted-foreground' : ''}
                `}>
                  {step?.title}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressTracker;